import * as t from 'io-ts';

export const CreateAccountResponseDynamicType = t.interface({
    confirmationEmailSenderAddress: t.string
});

export type CreateAccountResponse = t.TypeOf<typeof CreateAccountResponseDynamicType>;
